export const Bio = {
  title: "Greetings, I am Abhishek Mishra",
  roles: [
    "App Developement",
    "Web Developement",
    "Problem Solving"
  ],
  description: "Recent graduate in Computer Science Engineering with experience in software development, particularly in web and app development. Passionate about coding and problem-solving, I have worked on various projects and participated in hackathons.",
  github: "https://github.com/abhi-mis",
  resume: "https://drive.google.com/file/d/1xyz1234567890/view", // Replace with your resume link
  linkedin: "https://www.linkedin.com/in/abhiconnect/",
};

export const experience = [
  {
      id: 1,
      role: "Junior Software Developer",
      company: "Atomos Technology",
      date: "Jan 2023 - Dec 2023",
      description: "Worked on frontend development using React and Node.js. Developed several key features for the platform and collaborated with a team of engineers to enhance product scalability.",
      tags: ["React", "Node.js", "JavaScript"],
      image: "path_to_image", // Use the correct image path
  },
  {
      id: 2,
      role: "App Development Mentor",
      company: "The Coder's Club",
      date: "May 2022 - Nov 2022",
      description: "Mentored students in app development, focusing on Flutter and Dart. Conducted workshops and guided them through building functional mobile applications.",
      tags: ["Flutter", "Dart", "Mentorship"],
      image: "path_to_image", // Use the correct image path
  },
  {
      id: 3,
      role: "Club Editor",
      company: "Rotaract Club of MCKVIE",
      date: "Aug 2021 - Mar 2022",
      description: "Handled editorial responsibilities and managed content for club events. Worked closely with the team to promote initiatives and publish newsletters.",
      tags: ["Content Management", "Leadership"],
      image: "path_to_image", // Use the correct image path
  },
];

export const skills = [
  {
    title: "Languages",
    skills: [
      {
        name: "C/C++",
        icon: "fas fa-code", // Generic code icon as Font Awesome lacks a specific C/C++ icon
      },
      {
        name: "Java",
        icon: "fab fa-java", // Java icon from Font Awesome
      },
      {
        name: "Python",
        icon: "fab fa-python", // Python icon from Font Awesome
      },
      {
        name: "JavaScript",
        icon: "fab fa-js", // JavaScript icon from Font Awesome
      },
      {
        name: "HTML/CSS",
        icon: "fab fa-html5", // HTML5 icon from Font Awesome
      },
      {
        name: "Solidity",
        icon: "fas fa-file-code", // Generic code file icon for Solidity
      },
      {
        name: "Dart",
        icon: "fas fa-bullseye", // Generic icon since Dart doesn’t have a specific one
      },
      
    ],
  },
  {
    title: "Frameworks",
    skills: [
      {
        name: "ReactJS",
        icon: "fab fa-react", // ReactJS icon from Font Awesome
      },
      {
        name: "NodeJS",
        icon: "fab fa-node", // NodeJS icon from Font Awesome
      },
      {
        name: "NextJS",
        icon: "fas fa-code-branch", // Generic branch icon for NextJS
      },
      {
        name: "ExpressJS",
        icon: "fas fa-server", // Generic server icon for ExpressJS
      },
      {
        name: "Flutter",
        icon: "fas fa-mobile-alt", // Generic mobile icon for Flutter
      },
      {
        name: "Bootstrap",
        icon: "fab fa-bootstrap", // Bootstrap icon from Font Awesome
      },
      {
        name: "Hardhat",
        icon: "fas fa-hat-cowboy", // Generic cowboy hat icon for Hardhat (since it doesn't have a specific one)
      },
      {
        name: "Ethers.js",
        icon: "fas fa-link", // Generic link icon for Ethers.js
      },
      {
        name: "TailwindCSS",
        icon: "fab fa-css3-alt", // CSS3 icon for TailwindCSS
      },
    ],
  },
  {
    title: "Database",
    skills: [
      {
        name: "Firebase",
        icon: "fas fa-fire", // Fire icon for Firebase
      },
      {
        name: "MongoDB",
        icon: "fas fa-leaf", // Custom leaf icon for MongoDB
      },
      {
        name: "PostgreSQL",
        icon: "fas fa-database", // Generic database icon for PostgreSQL
      },
    ],
  },
  {
    title: "Tools",
    skills: [
      {
        name: "Git",
        icon: "fab fa-git-alt", // Git icon from Font Awesome
      },
      {
        name: "VS Code",
        icon: "fas fa-code", // Generic code icon for VS Code
      },
      {
        name: "PyCharm",
        icon: "fas fa-laptop-code", // Generic laptop code icon for PyCharm
      },
      {
        name: "Android Studio",
        icon: "fas fa-mobile-alt", // Mobile icon for Android Studio
      },
      {
        name: "RESTapi",
        icon: "fas fa-network-wired", // Network icon for REST API
      },
      {
        name: "Docker",
        icon: "fab fa-docker", // Docker icon from Font Awesome
      },
      {
        name: "AWS",
        icon: "fab fa-aws", // AWS icon from Font Awesome
      },
      {
        name: "GCP",
        icon: "fab fa-aws", // AWS icon from Font Awesome
      },
      {
        name: "Travis CI",
        icon: "fas fa-tools", // Tools icon for Travis CI
      },
    ],
  },
];



export const projects = [
  {
    id: 1,
    title: "BlockFI",
    date: "June 2024 - Present",
    description: "Designed and developed features for a Decentralized Finance platform leveraging blockchain technology. Facilitated peer-to-peer financial services like lending, borrowing, and trading through smart contracts written in Solidity. Utilized stablecoins to minimize market volatility and enhance user experience within the DeFi ecosystem.",
    image: "https://i.imghippo.com/files/kNS6R1726049598.png", // Replace with the link to the project image
    tags: [
      "NextJS",
      "Tailwind CSS",
      "TypeScript",
      "EthersJS",
      "NodeJS",
      "Solidity",
      "Metamask"
    ],
    category: "web",
    github: "https://github.com/abhi-mis/BlockFI",
    webapp: "https://block-fi.vercel.app", // Replace with the link to the live project or demo
  },
  {
    id: 2,
    title: "Pix-Mender",
    date: "February 2024",
    description: "Developed a web application using ReactJS, Express JS, Node JS, JavaScript, CSS, and Firebase that streamlines the process of uploading IDs, photos, and signatures to admission portals. Implemented a user-friendly interface where users can upload their documents all in one place. The application automatically categorizes and stores these documents in a Firebase database, organizing them into separate folders for photos, signatures, and ID documents.",
    image: "https://i.imghippo.com/files/SiJUY1726049662.png", // Replace with the link to the project image
    tags: [
      "ReactJS",
      "Express JS",
      "Node JS",
      "JavaScript",
      "CSS",
      "Firebase"
    ],
    category: "web",
    github: "https://github.com/abhi-mis/PixMender",
    webapp: "https://pixmender.netlify.app", // Replace with the link to the live project or demo
  },
  {
    id: 3,
    title: "Pragati 2024",
    date: "March 2024",
    description: "Designed and developed features for a Decentralized Finance platform leveraging blockchain technology. Facilitated peer-to-peer financial services like lending, borrowing, and trading through smart contracts written in Solidity. Utilized stablecoins to minimize market volatility and enhance user experience within the DeFi ecosystem.",
    image: "https://i.imghippo.com/files/XwhrH1726049966.png", // Replace with the link to the project image
    tags: [
      "ReactJS",
      "Tailwind CSS",
      "JavaScript",
      "NodeJS",
      "MongoDB",
      "Firebase",
      "Vercel"
    ],
    category: "web",
    github: "https://github.com/abhi-mis/Pragati2024",
    webapp: "https://pragati2024.online", // Replace with the link to the live project or demo
  },
  {
    id: 4,
    title: "Pipeline Designer",
    date: "August 2024",
    description: "Designed and developed features for a Decentralized Finance platform leveraging blockchain technology. Facilitated peer-to-peer financial services like lending, borrowing, and trading through smart contracts written in Solidity. Utilized stablecoins to minimize market volatility and enhance user experience within the DeFi ecosystem.",
    image: "https://i.imghippo.com/files/5FbRF1726050117.png", // Replace with the link to the project image
    tags: [
      "ReactJS",
      "CSS",
      "JavaScript",
      "NodeJS",
      "MongoDB",
      "Firebase",
      "Python"

    ],
    category: "web",
    github: "https://github.com/abhi-mis/Pipeline-Designer",
    webapp: "https://pipeline-designer-delta.vercel.app/", // Replace with the link to the live project or demo
  },
  // Add more projects following the same structure
];
